<template>
    <div class="app">
        <header>
            <i class="el-icon-arrow-left"  @click="$router.go(-1)"></i>
            <span class="pageTitle">更换手机号</span>
        </header>
        <div class="content">
            <div class="blank"></div>
            <div class="firstIn" v-if="!really">
                <div class="phoneIcon"><img src="../../assets/images/phoneNum.png" alt=""></div>
                <div class="phoneNum">当前手机号：{{oldPhone}}</div>
                <div class="button"><button @click="reallyChange">更换手机号</button></div>
            </div>
            <div class="nextIn" v-else>
                <ul>
                    <li>
                        <span>新手机号</span>
                        <input type="tel" v-model="phone" @blur="phone" maxlength="11" placeholder="请输入手机号">
                    </li>
                    <li>
                        <span>验证码</span>
                        <input type="text" v-model="verifyCode" maxlength="6" placeholder="请输入验证码">
                        <button @click.prevent="getCode">{{computeTime > 0 ? '重新发送'+computeTime + 's' : '发送'}}</button>
                    </li>
                </ul>
                <div class="button"><button @click="verifyLogin">确   认</button></div>
            </div>
        </div>
    </div>
</template>
<script>
import { Toast } from "mint-ui";
import { setInterval, clearInterval } from 'timers';
import { getUserChangeMobileAction, updateUserMobileAction } from '../../assets/js/api'

export default {
  data() {
    return {
      really: false,
      oldPhone:"",
      verifyCode: "", //验证码
      phone: "", //新的手机号
      computeTime:0,
    };
  },
  computed: {
      
  },
  mounted () {
      this.oldPhone = this.$route.query.mobile
  },
  methods: {
      //确认更换
        reallyChange(){
            this.really = true;
            console.log(this.really,"点一下，很开心")
        },
        // 获取验证码
        getCode(){
            var regu1 = /^1[3,4,5,7,8]\d{9}$/;
            if(!this.computeTime){
                //获取验证码
                if(regu1.test(this.phone)){
                    //判断是否输入原手机号
                    if(this.phone == this.oldPhone){
                        Toast:Toast({
                        message:'您当前已经绑定该手机',
                        position: 'middle',
                        duration: 2500
                        })
                    }else{
                        getUserChangeMobileAction(this.phone).then(res => {
                            console.log(res);
                            if(res.s == 0){
                                // 启动倒计时
                                this.computeTime = res.nextTime;
                                const intervalId = setInterval(() =>{
                                this.computeTime--;
                                // console.log(this.computeTime);
                                if(this.computeTime <= 0){
                                    clearInterval(intervalId);
                                }
                            },1000);
                            }
                            switch(res.s){
                                case 0:
                                Toast: Toast({
                                message: '发送成功',
                                position: 'middle',
                                duration: 1000
                                });
                            }
                        })
                        .catch(err =>{
                            Toast:Toast({
                                message:'网络不给力',
                                position: 'middle',
                                duration: 2500
                            })
                        })
                    }
                }else{
                    Toast:Toast({
                        message:'请输入正确的手机号',
                        position: 'middle',
                        duration: 2500
                    })
                }
            }
        },
        //  验证码登录
        verifyLogin()
        {
            console.log(1)
            if(!this.phone)
            {
                // this.msg = "请输入正确的手机号";
                // this.popupVisible = true;
                Toast({
                    message: '请输入正确的手机号',
                    position: 'middle',
                    duration: 3000
                    });
                return false;
            }
            if(!(/^1[3,4,5,7,8]\d{9}$/.test(this.phone)))
            {
                // this.msg = "请输入正确的手机号";
                // this.popupVisible = true;
                Toast({
                    message: '请输入正确的手机号',
                    position: 'middle',
                    duration: 3000
                    });
                return false;
            }
            // else if(!(/^\d{6}$/.test(this.verifyCode)))
            // {
                // Toast({
                //     message: ' 验证码错误，请重新输入！',
                //     position: 'middle',
                //     duration: 3000
                //     });
                // return false;
            // }
            else if(this.verifyCode=="")
            {
                // this.msg = "请输入正确验证码";
                // this.popupVisible = true;
                Toast({
                    message: '验证码错误，请重新输入！',
                    position: 'middle',
                    duration: 3000
                    });
                return false;
            }
            console.log('hahah');
            if (this.phone && this.verifyCode)
            {
                updateUserMobileAction(this.phone, this.verifyCode).then ( res => {
                    if (res.s == 0) {
                        Toast({
                            message: '更换绑定手机成功！',
                            position: 'middle',
                            duration: 2500
                        });
                        this.$router.back()
                    }
                }).catch(err => {
                    console.log('loginErro', err)
                })
            }

        },

        // 存储成功
         onGetSucc(obj)
        {
          //  alert("存储数据成功onGetSucc:"+obj.uid+"sign:"+obj.sign+"mode:"+obj.mode+"sessionId:"+obj.sessionId)
        },
        // 存储失败
        onGetError(obj)
        {
          // alert("存储数据失败onGetError:"+obj)
        },
        oneSelf(pass) {
          //  console.log(pass)
          var regu2 = /^\d{4}$/;
          if (regu2.test(pass)) {
            //手机号验证通过需执行的代码
          } else {
            this.popupVisible = true;
            // this.sendTne = false;
            // this.msg="请输入正确的验证码"
          }
        },
  }
};
</script>
<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
header {
  height: 1.5rem;
  width: 100%;
  background-image: linear-gradient(-134deg, #299ead 0%, #299ead 100%);
  position: fixed;
  z-index: 1;
}
.blank {
  height: 1.5rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 38%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  background-color: rgba(241, 241, 241, 1);
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}
i.el-icon-arrow-right {
  float: right;
  color: rgba(0, 0, 0, 1);
  margin-top: 0.5rem;
  font-size: 0.55rem;
  margin-right: 0.6rem;
}
.firstIn {
  width: 100%;
  height: 7.2rem;
  margin-top: 0.26rem;
  text-align: center;
}
.nextIn {
  text-align: center;
}
.phoneIcon {
  padding-top: 0.84rem;
}
.phoneIcon img {
  width: 2.71rem;
  height: 2.71rem;
}
.phoneNum {
  font-size: 0.42rem;
  color: rgba(0, 0, 0, 0.9);
  line-height: 0.61rem;
  text-align: center;
  margin-top: 0.18rem;
}
.button button {
  margin-top: 0.97rem;
  width: 5.92rem;
  height: 1.05rem;
  color: #fff;
  font-size: 0.53rem;
  background-color: rgba(41, 158, 173, 1);
  border-radius: 0.16rem;
  border: 0.03rem solid rgba(255, 255, 255, 0);
}
.nextIn ul {
  height: 2.55rem;
  width: 100%;
  background-color: #fff;
}
.nextIn ul li {
  height: 1.26rem;
  line-height: 0.61rem;
  margin-left: 0.53rem;
  font-size: 0.42rem;
  border-bottom: 0.03rem solid rgba(0, 0, 0, 0.1);
  text-align: left;
  position: relative;
}
.nextIn ul li :nth-child(1) {
  position: absolute;
  top: 0.34rem;
}
.nextIn ul li :nth-child(2) {
  border: none;
  width: 2.7rem;
  height: 0.61rem;
  position: absolute;
  top: 0.34rem;
  left: 3.21rem;
}
.nextIn ul li :nth-child(3) {
  width: auto;
  height: 0.79rem;
  position: absolute;
  top: 0.25rem;
  right: 0.39rem;
  padding: 0.1rem 0.3rem;
  color: #fff;
  font-size: 0.37rem;
  background-color: rgba(41, 158, 173, 0.78);
  border-radius: 0.11rem;
  border: 0.03rem solid rgba(255, 255, 255, 0);
}
</style>



// WEBPACK FOOTER //
// src/components/mine/changePhone.vue